import React from "react";
import { makeStyles } from "@mui/styles";
import SaviRuchi1 from "../../../assets/Images/SaviRuchi1.jpeg";
import SaviRuchi2 from "../../../assets/Images/SaviRuchi2.jpeg";

const useStyles = makeStyles((theme) => ({
  page: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "#ffffff",
    padding: "40px 20px",
    boxSizing: "border-box",
    overflowY: "auto",
    fontFamily: "'Inter', sans-serif",
  },

  contentWrapper: {
    width: "100%",
    maxWidth: "1200px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "40px",
  },

  imageGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
    gap: "30px",
    width: "100%",
    justifyContent: "center",
  },

  posterCard: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
    },
  },

  poster: {
    width: "100%",
    height: "auto",
    display: "block",
    borderRadius: "16px",
  },

  button: {
    marginTop: "10px",
    padding: "16px 40px",
    fontSize: "18px",
    fontWeight: "600",
    color: "#fff",
    backgroundColor: "#000000",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    textDecoration: "none",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    marginBottom: "40px",
    "&:hover": {
      backgroundColor: "#333333",
      transform: "scale(1.05)",
      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
    },
  },
}));

const Layout = () => {
  const classes = useStyles();

  return (
    <div className={classes.page}>
      <div className={classes.contentWrapper}>

        {/* Image Grid */}
        <div className={classes.imageGrid}>
          <div className={classes.posterCard}>
            <img
              src={SaviRuchi1}
              alt="Saviruchi Poster 1"
              className={classes.poster}
            />
          </div>
          <div className={classes.posterCard}>
            <img
              src={SaviRuchi2}
              alt="Saviruchi Poster 2"
              className={classes.poster}
            />
          </div>
        </div>

        {/* Survey Button */}
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSd9NKTgtZdSZgNBTsI8H-E7foumcI7ibtFhHmvrZGPYPqcWOA/viewform?usp=publish-editor"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.button}
        >
          Add preference
        </a>

      </div>
    </div>
  );
};

export default Layout;
